/**
 * useAuth - 认证状态管理组合式函数（Pinia 封装）
 *
 * 提供与原接口兼容的 API，底层使用 Pinia store
 */
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '../stores/auth'

export function useAuth() {
  const authStore = useAuthStore()
  const {
    token: authToken,
    userInfo: authUserInfo,
    ready: authReady,
    error: authError,
    bets: authBets,
  } = storeToRefs(authStore)

  // 当前账户币种代码（CNY / USD ...）
  const authCurrency = computed(() => authBets.value?.currency || null)

  /**
   * 执行页面初始化流程（login -> fetchBalance -> bets）
   *
   * @param gameCode 當前 gameId；bets 已改 per-game 端點，缺值則跳過 bets。
   */
  async function doAuthenticate(gameCode?: string | null): Promise<boolean> {
    return authStore.bootstrap(gameCode)
  }

  /**
   * 静默续期 token（不触发加载动画）
   */
  async function doRefreshToken(): Promise<boolean> {
    return authStore.refreshAuth()
  }

  /**
   * 调用登出接口
   */
  async function doLogout(): Promise<void> {
    return authStore.logout()
  }

  /**
   * 处理 token 失效（调用 store 的 invalidate）
   */
  function handleAuthInvalid(onInvalid?: () => void) {
    authStore.invalidate()
    onInvalid?.()
  }

  /**
   * 重置认证状态
   */
  function resetAuth() {
    authStore.reset()
  }

  return {
    authToken,
    authUserInfo,
    authReady,
    authError,
    authCurrency,
    authBets,
    doAuthenticate,
    doRefreshToken,
    doLogout,
    handleAuthInvalid,
    resetAuth,
  }
}
